
export class ArquivoInscricao {
    codigoArquivo: number;
    numeroInscricao: number;
    itemConcurso: number;
    tipoArquivo: number;
    descricao: string;    
    referenciaApi: string;
    dataEnvio: Date;
    concurso: number;
  }


// WEBPACK FOOTER //
// ./src/app/models/arquivoInscricao.ts